export default {
    groupName: 'optimum',
    appName: 'Optimum',
    baseRoute: '/dashboard/optimum',
    label: 'Optimum Business Ad Effect Tracker',
    home: '/slicer',
    image: 'optimum-business.png',
    description: 'Optimum Business Ad Effect Tracker'
}


// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/main.js